import { combineReducers } from "redux";

import { divingDepartmentDetails } from "./reducer.divingdepartment"
const divingDepartmentReducers = combineReducers({

  divingDepartmentDetails

})
export default divingDepartmentReducers;
